import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface OemSegmentNameCellProps {
  rowData: ManagedFleet;
}

export default function OemSegmentNameCell({
  rowData: { sentinelTeam },
}: OemSegmentNameCellProps) {
  return <TextCell text={sentinelTeam?.oemSegment?.name} />;
}
